import { RouteObject } from "react-router-dom";
import ReadCycleLanding from "./components/landing/landing";
import CreateReadCycle from "./components/create/create";
import { ReadCycleDetailsLanding } from "./components/details/landing";
import ScheduleCreate from "./components/schedule/create/create";
import ScheduleDetailsLanding from "./components/schedule/details/landing";

export interface mxReadCycleManagementRoute
  extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: mxReadCycleManagementRoute[];
}
export const mxReadCycleManagementRoutes: mxReadCycleManagementRoute[] = [
  {
    path: "/mx/read-cycle/",
    element: <ReadCycleLanding />,
  },
  {
    path: "/mx/read-cycle/:action",
    element: <CreateReadCycle />,
  },
  {
    path: "/mx/read-cycle/:action/:cycle_id",
    element: <CreateReadCycle />,
  },
  {
    path: "/mx/read-cycle/view/view-details/:cycle_id/:route_name",
    element: <ReadCycleDetailsLanding />,
  },
  {
    path: "/mx/schedule/:action",
    element: <ScheduleCreate />,
  },
  {
    path: "/mx/schedule/:action/:schedule_id",
    element: <ScheduleCreate />,
  },
  {
    path: "/mx/schedule/view/view-details/:schedule_id",
    element: <ScheduleDetailsLanding />,
  },
];
